import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { API } from "../../config/config";
import { api_guards_routes } from "../../config/apiRoutes";
import { GuardState } from "../../types/types";

const initialState: GuardState = {
  loading: false,
  error: null,
  data: null,
};

export const createGuard = createAsyncThunk(
  "guards/createGuard",
  async (newData: any, { rejectWithValue }) => {
    try {
      const response = await API.POST(
        api_guards_routes.getAll_and_create,
        newData
      );
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data.error || error.message);
    }
  }
);

export const fetchGuards = createAsyncThunk(
  "guards/fetchGuards",
  async (
    {
      assignedBuilding,
      query,
    }: { assignedBuilding?: string; query?: string } = {},
    { rejectWithValue }
  ) => {
    try {
      const url =
        query || assignedBuilding
          ? `${api_guards_routes.getAll_and_create}?${
              query ? `query=${query}&` : ""
            }${assignedBuilding ? `assignedBuilding=${assignedBuilding}` : ""}`
          : api_guards_routes.getAll_and_create;

      const response = await API.GET(url);
      return response.data;
    } catch (error: any) {
      console.log({ error });
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);
export const updateGuard = createAsyncThunk(
  "guards/updateGuard",
  async ({ id, newData }: any, { rejectWithValue }) => {
    try {
      const response = await API.PUT(
        `${api_guards_routes.getAll_and_create}/${id}`,
        newData
      );
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data.error || error.message);
    }
  }
);
export const deleteGuard = createAsyncThunk(
  "guards/deleteGuard",
  async (id: string, { rejectWithValue }) => {
    try {
      await API.DELETE(`${api_guards_routes.getAll_and_create}/${id}`);
      return id;
    } catch (error: any) {
      return rejectWithValue(error.response?.data.error || error.message);
    }
  }
);

const guardSlice = createSlice({
  name: "guards",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(createGuard.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createGuard.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(createGuard.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(fetchGuards.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchGuards.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchGuards.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(deleteGuard.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteGuard.fulfilled, (state, action) => {
        state.loading = false;
        // if (state.data ) {
        //   state.data = state?.data?.filter(
        //     (guard: any) => guard._id !== action.payload
        //   );
        // }
      })
      .addCase(updateGuard.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(deleteGuard.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export default guardSlice.reducer;
